var applyQrCode = require('widgets/applyQrCode')
  , $ = require('jquery')
  , giftButtonTmpl = require('./giftButton.handlebars')
  , clickOutside = require('@173js/ui/clickOutside')
  , pingjs = require('widgets/ping')
  , engageCurrentGame = require('game-info/sections/profile/engageCurrentGame')
  , requireLogin = require('widgets/requireLogin')
  , GetDownloadUrls = require('widgets/getDownloadUrls')
  , channelDlTmpl = require('./channelDl.handlebars')

$(function() {
  var headerGameInfo = $('.game-info-section')
  , ued = window.ued || {}
  , transferUrl = 'https://'+window.location.host+'/track/download'
  , ssid = ued.pingjs.get('ssid')
  , data = {gameCode:ued.gameCode}

  if (!headerGameInfo.length) {return}

  var newGameCodes = {};
  if (typeof ued.newgameCodes.iOS != 'undefined') {
    newGameCodes.ios = ued.newgameCodes.iOS
  }
  if (typeof ued.newgameCodes.Android != 'undefined') {
    newGameCodes.android = ued.newgameCodes.Android
  }
  var getDownloadUrls = new GetDownloadUrls(newGameCodes);
  // 判断有没有雷电合作链接
  $.when(getDownloadUrls.getPlatformUrl('100000'+ued.gameId, true))
    .then(function (res) {
      // source 为 20 表示是联运的，为 40 表示是官方
      if (res.data && res.data.source == 20) {
        data.hasPcDl = true
        data.pcDlUrl = res.data.downloadUrl
      }
      render()
    })
  
  function render() {
    getDownloadUrls.getUrls(function(urls) {
      $.each(urls, function(plat, url) {
        if (plat == 'ios') {
          data.hasIosDl = true
          data.iosInfo = {
            url: transferUrl+'?code='+newGameCodes.ios+'&ssid='+ssid+''
          }
        }
        if (plat == 'android') {
          data.hasAndroidDl = true
          data.androidInfo = {
            url: transferUrl+'?code='+newGameCodes.android+'&ssid='+ssid+''
          }
        }
      })
      headerGameInfo.find('.pn-game-in').append(channelDlTmpl(data))
  
      if (headerGameInfo.find('.channel-pop-ios').length) {
        pandora.use([ 'qrcode'], function(Qrcode) {
          new Qrcode({
            element: '.channel-pop-ios .channel-avatar',
            text: data.iosInfo.url,
            size : 130
          });
        });
      }
      if (headerGameInfo.find('.channel-pop-android').length) {
        pandora.use([ 'qrcode'], function(Qrcode) {
          new Qrcode({
            element: '.channel-pop-android .channel-avatar',
            text: data.androidInfo.url,
            size : 130
          });
        });
      }
    })
  }

  var hasGift = !!$('#gift-section').length
  if (hasGift) {
    headerGameInfo.find('.gift-button-placeholder').replaceWith(
      $(giftButtonTmpl())
    )
  }

  var timeoutObj = null;
  headerGameInfo
    .on('mousedown', '.channel-dl-pc'
      , function(e) {
        var el = $(e.currentTarget)
        if (el.hasClass('channel-disabled')) { return }
        pingjs.trackEvent('DOWNLOAD_MOBILE_GAME_SIMULATOR', window.location.href)
      })
    .on('click', '.btn-engage-current-game', requireLogin(engageCurrentGame))
    .on('mouseenter mouseleave', '.channel-dl-and, .channel-dl-ios', function(e) {
        var el = $(e.currentTarget);
        if(e.type == "mouseenter"){
          (function(me){
            timeoutObj = setTimeout(function(){
              if(el.hasClass('channel-dl-and')) {
                pingjs.trackEvent('ANDROID_GAME_DOWNLOADED_IN_PC', window.location.href)
              }
              if(el.hasClass('channel-dl-ios')) {
                pingjs.trackEvent('IOS_GAME_DOWNLOADED_IN_PC', window.location.href)
              }
            },3000);
          }(this));
        }else if(e.type == "mouseleave"){
          if(timeoutObj != null){
              clearTimeout(timeoutObj);
          }
        }
      })
    .on('mousedown', '.channel-dl-and, .channel-dl-ios', function(e) {
      var el = $(e.currentTarget);
      if(el.hasClass('channel-dl-and')) {
        pingjs.trackEvent('ANDROID_GAME_DOWNLOADED_IN_PC', window.location.href)
      }
      if(el.hasClass('channel-dl-ios')) {
        pingjs.trackEvent('IOS_GAME_DOWNLOADED_IN_PC', window.location.href)
      }
    })
  
})
